import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-expo',
  templateUrl: './business-expo.component.html',
  styleUrls: ['./business-expo.component.scss']
})
export class BusinessExpoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
